import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import zh from './locales/zh.json';
import zhTW from './locales/zh-TW.json';
import en from './locales/en.json';
import vi from './locales/vi.json';
import km from './locales/km.json';

export const SUPPORTED_LOCALES = ['zh', 'zh-TW', 'en', 'vi', 'km'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];

const STORAGE_KEY = 'gpl.locale';

function resolveInitialLocale(): SupportedLocale {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored && (SUPPORTED_LOCALES as readonly string[]).includes(stored)) {
    return stored as SupportedLocale;
  }
  const browser = navigator.language;
  if (browser.startsWith('zh-TW') || browser.startsWith('zh-HK')) return 'zh-TW';
  if (browser.startsWith('zh')) return 'zh';
  if (browser.startsWith('vi')) return 'vi';
  return 'en';
}

void i18n.use(initReactI18next).init({
  resources: {
    zh: { translation: zh },
    'zh-TW': { translation: zhTW },
    en: { translation: en },
    vi: { translation: vi },
    km: { translation: km },
  },
  lng: resolveInitialLocale(),
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(locale: SupportedLocale): void {
  localStorage.setItem(STORAGE_KEY, locale);
  void i18n.changeLanguage(locale);
}

export default i18n;
